import React, { useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "../styles/SideFilters.module.css";
import loadStyle from "../styles/LoadingCard.module.css";

function FiltersModal(props: any) {

 

  const handleCheckboxChange = (e: any, val: any, id: any) => {
    props.setCatCahnge(true);
    const newValues = { ...props.seeMoreFiltersData };
    const updated = newValues[val]?.values?.map((item: any, i: any) => {
      if (i === id && newValues[val].inputType === "checkbox") {
        return { ...item, isChecked: e.target.checked };
      } else if (newValues[val].inputType === "radio") {
        if (i === id) {
          return { ...item, isChecked: e.target.checked };
        } else {
          return { ...item, isChecked: false };
        }
      }
      return item;
    });
    props.setSeeMoreFiltersData({ ...newValues, [val]: { ...newValues[val], values: updated } });
  };
  const handleSubmit = () => {
    props.onHide();
    if (props.filtersTitle === "independent") {
      props.setFiltersData({ ...props.filtersData, [props.filterObject]: props.seeMoreFiltersData[props.filterObject] });
    } else {
      props.setdependentFilters({ ...props.dependentFilters, [props.filterObject]: props.seeMoreFiltersData[props.filterObject] });
    }
    // setfiltersData({ ...newValues, [val]: { ...newValues[val], values: updated } });
    props.setCatCahnge(true);
  };

  const onCancel = () => {
    props.onHide();
  };

  return (
    <div>
      <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered onHide={props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title className="py-2" id="contained-modal-title-vcenter">
            {props?.seeMoreFiltersData[props.filterObject]?.label?.toUpperCase()}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className={`d-flex px-3 ${styles.filtersModalBody}`}>
            {props.loading?<LoadingFields/>:<>
              {props?.seeMoreFiltersData &&
                Object.keys(props?.seeMoreFiltersData).map((val: any, i: any) => (
                  <>
                    {props?.seeMoreFiltersData[val].values.map((item: any, index: any) => {
                      
                      return(
                      <Col lg="6" key={index}>
                        
                        
                        <Form.Check
                          key={index}
                          className={`${styles.checkbox}`}
                          onChange={(e) => handleCheckboxChange(e, val, index)}
                          name={`${val}-1`}
                          checked={item.isChecked}
                          type={props?.seeMoreFiltersData[val].inputType}
                          id={`${index}`}
                          label={`${item.label === 0 ? "No" : item.label === 1 ? "Yes" : item.label}${props?.seeMoreFiltersData[val].unit !== null ? ` ${props?.seeMoreFiltersData[val].unit}` : ""}${props.specs?"":`(${item.count})`}`}
                        />
                      </Col>
                    )})}
                  </>
                ))}
            </>}
          </Row>
          <Row className="d-flex mt-3">
            <Col className="d-flex justify-content-end  ">
              <Button onClick={onCancel} variant="outline-primary mx-2  ">
                Cancel
              </Button>
              <Button onClick={handleSubmit} variant="primary">
                Submit
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default FiltersModal;

const LoadingFields = () => {
  let loadArray = [1, 2, 3, 4, 5];

  return (
    <>
      {loadArray?.map((item: number) => (
        <Col lg="6">
          <h5 style={{ width: "150px", height: "27px" }} className={` ${loadStyle.skeleton} fw-bold my-2 fs-16 m-0`}></h5>
        </Col>
      ))}
    </>
  );
};
